import React, { Component } from 'react';
import Package from './../../package.json';
import LogoutBox from './LogoutBox.js';


export default class UserInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: null
		}
	}

	componentWillMount() {
		var user = JSON.parse(localStorage.getItem('user'));
		this.setState({user: user})
	}

	render() {
		const {user} = this.state;
		return(
			<div>
			{(user)?
			<div className="logout-wrapper">
				<div>
					<div className="initial-avtr">{user.bradmanUserProfile.displayName.charAt(0)}</div>
				</div>
				<div className="top-ten">
					<div className="logout-user-name">{user.bradmanUserProfile.displayName}</div>
					<div className="logout-o-inf">({user.bradmanUserProfile.emailId})</div>
				</div>
				<div className="logout-o-inf top-ten hidden-xs">
					App Version : {Package.version}
				</div>
				<div className="top-ten hidden-xs">
					<LogoutBox/>
				</div>
			</div>:null
			}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/commons/UserInfo.js